import React from 'react';

interface LegendItemProps {
  item: Record<string, string>;
}

const LegendItem: React.FC<LegendItemProps> = ({ item }) => {
  return (
    <div className="flex items-center py-2 gap-1">
      <div 
        className="w-3 h-1 rounded-full" 
        style={{ backgroundColor: item.color }}
      />
      <div className="text-xs font-medium">
        {item.label}
      </div>
    </div>
  );
};

interface LegendProps {
  items: Array<Record<string, string>>;
}

export const Legend: React.FC<LegendProps> = ({ items }) => {
  return items.length ? (
    <div className="flex items-center gap-3">
      {items.map((item: Record<string, string>, index) => (
        <LegendItem item={item} key={index} />
      ))}
    </div>
  ) : null;
};
